import { createApp } from "vue";
import "vue-toastification/dist/index.css";
import Toast from "vue-toastification";
import { registerAllComponents } from "./register";
import "element-plus/es/components/base/style/css";
import "../../style.scss";
import "@f360-dev/f360-prisma/style.css";
import { initializeBaseUrls } from "@/core/services/protocols";
import { bootstrapVueComponents } from "./bootstrap";

function mountToastHost() {
  let host = document.getElementById("vc");
  if (!host) {
    host = document.createElement("div");
    host.id = "vc";
    document.body.appendChild(host);
  }
  const app = createApp({
    render: () => null
  });
  app.use(Toast);
  app.mount(host);
}

bootstrapVueComponents({
  initializeBaseUrls,
  registerAllComponents,
  mountToastHost
}).catch((err) => console.error("[vue-components]", err));
